import { render, staticRenderFns } from "./calendarWeek.vue?vue&type=template&id=3fef7334&"
import script from "./calendarWeek.vue?vue&type=script&lang=js&"
export * from "./calendarWeek.vue?vue&type=script&lang=js&"
import style0 from "./calendarWeek.vue?vue&type=style&index=0&id=3fef7334&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports